import { useTranslation } from 'react-i18next';
import { usePageConfig } from '@/contexts/PageConfigContext';
import Error404 from '@/components/Error404';

const NotFoundPage = () => {
  const { t } = useTranslation('common');
  usePageConfig({ title: t('notFound'), showHeader: false, showBottomNav: false, showNavigation: false });

  return <Error404 />;
};

export default NotFoundPage;
